import React from "react";
import Skeleton from "react-skeleton-loader";
import Module from "../../Components/Module/Module";

export default class ListStoresSkeleton extends React.Component {
  render() {
    return (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr",
          gridRowGap: "1em"
        }}
      >
        <Module>
          <Skeleton height="1em" />
          <div style={{ marginTop: ".5em" }}>
            <Skeleton width="100%" />
          </div>
        </Module>

        <Module>
          <Skeleton height="1em" />
          <div style={{ marginTop: ".5em" }}>
            <Skeleton width="100%" />
          </div>
        </Module>

        <Module>
          <Skeleton height="1em" />
          <div style={{ marginTop: ".5em" }}>
            <Skeleton width="100%" />
          </div>
        </Module>
      </div>
    );
  }
}